import React, { useState } from 'react';
import { Card, Button, Container, Row, Col, Carousel } from "react-bootstrap";
import { Heart, ShoppingCart } from "lucide-react";
import Countdown from "react-countdown";
import "../Styles/TopDeals.css";
import { useNavigate, Link } from 'react-router-dom';


const dealsOfTheWeek = [
  {
    id: 1,
    img: require("../Images/deal1.jpeg"),
    name: "T. Stanes Biocure B 1ltr",
    category: "Insecticides, Fungicides",
    mrp: "₹582.00",
    discount: "5%",
    price: "₹550.00",
  },
  {
    id: 2,
    img: require("../Images/deal2.jpeg"),
    name: "Koppert Veni Cal",
    category: "Micro Nutrients, Stimulants & PGR",
    mrp: "₹560.00",
    discount: "16%",
    price: "₹470.00",
  },
  {
    id: 3,
    img: require("../Images/deal3.jpg"),
    name: "Mati Bone Meal",
    category: "Amendments, Fertilizers",
    mrp: "₹249.00",
    discount: "12%",
    price: "₹219.00",
  },
  {
    id: 4,
    img: require("../Images/deal4.jpeg"),
    name: "Tradecorp Quikon 20ml",
    category: "Stimulants & PGR",
    mrp: "₹593.00",
    discount: "3%",
    price: "₹575.00",
  },
  {
    id: 5,
    img: require("../Images/product4.png"),
    name: "T. Stanes Green Miracle",
    category: "Stimulants & PGR",
    mrp: "₹486.00",
    discount: "18%",
    price: "₹399.00",
  },
];

export default function DealsOfTheWeek({ handleCartClick, handleLikeClick}) {
  const [likedItems, setLikedItems] = useState([]);
  const [cartItems, setCartItems] = useState([]);

  const navigate = useNavigate();

  const toggleLike = (productId) => {
    setLikedItems((prevLiked) => {
      if (prevLiked.includes(productId)) {
        return prevLiked.filter((id) => id !== productId);
      } else {
        return [...prevLiked, productId];
      }
    });
  };
  const handleAddToCart = (product) => {
    if (!cartItems.includes(product.id)) {
      setCartItems((prev) => [...prev, product.id]); 
      handleCartClick(product);
    }
  };
  return (
    <Container fluid className="deals-of-the-week text-center mt-5 p-4 bg-primary text-white rounded">
      <h2>Deals Of The Week</h2>
      <p>Hurry up! Offer ends in</p>

      <div className="countdown-container">
      <Countdown
        date={Date.now() + 1000 * 60 * 60 * 24}
        renderer={({ hours, minutes, seconds, completed }) => {
          if (completed) {
            return <span className="text-danger fw-bold">Offer expired!</span>;
          } else {
            return (
              <div className="d-flex justify-content-center gap-3 fs-4">
                <div><span className="fw-bold">{String(hours).padStart(2, '0')}</span>h</div>
                <div><span className="fw-bold">{String(minutes).padStart(2, '0')}</span>m</div>
                <div><span className="fw-bold">{String(seconds).padStart(2, '0')}</span>s</div>
              </div>
            );
          }
        }}
      />
      </div>

      <Carousel indicators={false} controls={true} className="mt-4">
        <Carousel.Item>
          <Row className="justify-content-center">
            {dealsOfTheWeek.slice(0, 3).map((product) => (
              <Col key={product.id} xs={12} sm={6} md={4} className="mb-4">
                <Link to={`/product/${encodeURIComponent(product.name)}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                  <Card className="product-card shadow-lg mx-auto">
                  <div className="discount-badge">{product.discount} OFF</div>
                  <div className="d-flex justify-content-end">
                  <Heart
                  size={24}
                  color={likedItems.includes(product.id) ? "red" : "gray"} // Set color to red if liked, otherwise gray
                  className="cursor-pointer"
                  onClick={() => { toggleLike(product.id); handleLikeClick(product); }} // Toggle like and handle click
                />
                  </div>
                  <Card.Img variant="top" src={product.img} className="product-image" />
                  <Card.Body>
                    <p className="product-category">{product.category}</p>
                    <Card.Title className="product-title">{product.name}</Card.Title>
                    <p className="product-mrp text-muted">
                      <s>MRP: {product.mrp}</s>
                    </p>
                    <p className="product-price fw-bold">{product.price}</p>
                    <Button 
                  className="add-to-cart" 
                  onClick={() => handleAddToCart(product)} 
                  disabled={cartItems.includes(product.id)} 
                >
                  <ShoppingCart size={20} /> {cartItems.includes(product.id) ? "Added to Cart" : "Add to Cart"}
                </Button>
                  </Card.Body>
                </Card>
                </Link>
              </Col>
            ))}
          </Row>
        </Carousel.Item>

        <Carousel.Item>
          <Row className="justify-content-center">
            {dealsOfTheWeek.slice(3, 5).map((product) => (
              <Col key={product.id} xs={12} sm={6} md={4} className="mb-4">
                <Card className="product-card shadow-lg mx-auto">
                  <div className="discount-badge">{product.discount} OFF</div>
                  <div className="d-flex justify-content-end">
                    <Heart size={24} className="text-muted like-icon" />
                  </div>
                  <Card.Img variant="top" src={product.img} className="product-image" />
                  <Card.Body>
                    <p className="product-category">{product.category}</p>
                    <Card.Title className="product-title">{product.name}</Card.Title>
                    <p className="product-mrp text-muted">
                      <s>MRP: {product.mrp}</s>
                    </p>
                    <p className="product-price fw-bold">{product.price}</p>
                    <Button className="add-to-cart">
                      <ShoppingCart size={20} /> Add to Cart
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Carousel.Item>
      </Carousel>
    </Container>
  );
}
